import { render, staticRenderFns } from "./serversList.vue?vue&type=template&id=6f6ae6fb&"
import script from "./serversList.vue?vue&type=script&lang=js&"
export * from "./serversList.vue?vue&type=script&lang=js&"
import style0 from "./serversList.vue?vue&type=style&index=0&id=6f6ae6fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports